var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CsOnboardingSurvey',{attrs:{"user":_vm.currentUser,"token":_vm.token,"hutk":_vm.hutk,"api-base-url":_vm.apiBaseUrl,"language":_vm.currentLocale},on:{"set-company":_vm.handleSetCompany,"success":_vm.handleSuccess,"error":_vm.handleError}})
}
var staticRenderFns = []

export { render, staticRenderFns }